import { Skeleton } from '@mui/material'
import GraphLoadingImage from 'assets/graph-loading.svg?react'
import clsx from 'clsx'
import { Card, Rule, Statistic } from 'components/core-v2'

import { TradeTemplate } from '../../templates/trade-template'
import classes from './index.module.scss'

export const Loading = () => (
  <TradeTemplate tabValue="performance">
    <div className="d-flex justify-content-space-between">
      <Skeleton height="39px" width="320px" />
    </div>
    <div className={clsx(classes.statisticsWrapper, 'mt-8')}>
      <Card.Wrapper className={classes.cardWrapper} spacing="sm">
        <div className={classes.accountValueWrapper}>
          <Statistic.Wrapper>
            <Statistic.Header>Total account value</Statistic.Header>
            <Statistic.StatLoading />
          </Statistic.Wrapper>
        </div>
        <Rule className="mt-8 mb-5" />
        <div className={classes.relativeStatWrapper}>
          <Statistic.RelativeStatLoading />
        </div>
      </Card.Wrapper>
      <Card.Wrapper className={classes.cardWrapper} spacing="sm">
        <div className={classes.depositsWrapper}>
          <Statistic.Wrapper>
            <Statistic.Header>Deposits</Statistic.Header>
            <Statistic.StatLoading />
          </Statistic.Wrapper>
          <Statistic.Wrapper>
            <Statistic.Header>Withdrawals</Statistic.Header>
            <Statistic.StatLoading />
          </Statistic.Wrapper>
        </div>
        <Rule className="mt-10 mb-5" />
        <div className={classes.relativeStatWrapper}>
          <Statistic.RelativeStatLoading />
        </div>
      </Card.Wrapper>
      <Card.Wrapper spacing="sm">
        <Statistic.Wrapper>
          <Statistic.Header>Protection Amount</Statistic.Header>
          <Statistic.StatLoading />
        </Statistic.Wrapper>
        <Rule className="my-6" />
        <Statistic.Wrapper>
          <Statistic.Header>Current Allocation</Statistic.Header>
          <Statistic.StatLoading />
        </Statistic.Wrapper>
      </Card.Wrapper>
      <Card.Wrapper spacing="sm">
        <Statistic.Wrapper>
          <Statistic.Header>Maximum Drawdown</Statistic.Header>
          <Statistic.StatLoading />
        </Statistic.Wrapper>
        <Rule className="my-6" />
        <Statistic.Wrapper>
          <Statistic.Header>Realised Volatility</Statistic.Header>
          <Statistic.StatLoading />
        </Statistic.Wrapper>
      </Card.Wrapper>
    </div>
    <div className="mt-8">
      <Card.Wrapper className={clsx('mt-4', classes.skeleton, 'pulse')}>
        <GraphLoadingImage />
      </Card.Wrapper>
    </div>
  </TradeTemplate>
)
